import {
  GESTION_OPERATIVA_BON_ESPECIAL_USADO_ERROR,
  GESTION_OPERATIVA_SET_BON_ESPECIAL_USADO,
  GESTION_OPERATIVA_SET_IS_MODIFIED,
  GESTION_OPERATIVA_CLEAR_EXTRA_BONIF,
} from './constants';
import { formatNumber } from 'Utilities'

export function setBonEspecialUsado(bonEspecial,patente) {
  return (dispatch, getState) => {
    const { gestionOperativa } = getState();
    const {sale} = gestionOperativa;
    const takingCars = sale.Taking_cars;
    let modifiedTakingCars = [...takingCars];

    const currentCarIndex = takingCars?.findIndex(item => item.license_plate === patente)
    const currentCarData = takingCars[currentCarIndex]

    const peritajePrice = currentCarData.appraisal ? currentCarData.appraisal : currentCarData.original_price
    const currentCarFinalPrice = currentCarData.updatedTakePrice ? currentCarData.updatedTakePrice : peritajePrice

    // Borro la bonificción del usado actual y recalculo el R
    modifiedTakingCars[currentCarIndex].take_improvement_amount = 0;
    modifiedTakingCars[currentCarIndex].final_take_price = currentCarFinalPrice;

    const bonifMax = (gestionOperativa?.sale?.catalog_net_sale_price || 0) - (gestionOperativa?.sale?.special_discount || 0)

    if (bonEspecial > bonifMax && bonEspecial > 99) {
      dispatch({
        type: GESTION_OPERATIVA_BON_ESPECIAL_USADO_ERROR,
        data: {
          error: true,
          patente: patente,
          message: `El monto ingresado supera el límite de bonificación. Monto max: $${formatNumber.separator(bonifMax)}`
        }
      })
    } else if (bonEspecial < 100 && bonEspecial > 0) {
      dispatch({
        type: GESTION_OPERATIVA_BON_ESPECIAL_USADO_ERROR,
        data: {
          error: true,
          patente: patente,
          message: `El monto ingresado no puede ser menor a $100`
        }
      })
    } else {
      const currentNewCarFinalPrice = bonEspecial ? currentCarFinalPrice + bonEspecial : currentCarFinalPrice
      modifiedTakingCars[currentCarIndex] = {...modifiedTakingCars[currentCarIndex], final_take_price: currentNewCarFinalPrice, take_improvement_amount: bonEspecial}
      dispatch(
        dispatch({
          type: GESTION_OPERATIVA_SET_BON_ESPECIAL_USADO,
          data: modifiedTakingCars,
        }),
        dispatch({
          type: GESTION_OPERATIVA_SET_IS_MODIFIED,
          data: true
        })
      )
    }
  }
}

export function clearExtraBonif() {
  return (dispatch) => {
    dispatch({
      type: GESTION_OPERATIVA_CLEAR_EXTRA_BONIF,
    })
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case GESTION_OPERATIVA_SET_BON_ESPECIAL_USADO:
      return {
        ...state,
        bonEspecialUsadoError: null,
        sale: {
          ...state.sale,
          Taking_cars: action.data
        },
        saveButtonDisabled: false,
      }
    case GESTION_OPERATIVA_BON_ESPECIAL_USADO_ERROR:
      return {
        ...state,
        bonEspecialUsadoError: action.data,
        saveButtonDisabled: true,
      }
    case GESTION_OPERATIVA_CLEAR_EXTRA_BONIF:
      return {
        ...state,
        bonEspecialUsadoError: null,
        bonEspecialError: null,
      }
    default:
      return state
  }
}